import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitBidRequest = (fd: FormData) =>
  axios.post(`${API}/bid-requests`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const submitReview = (payload: unknown) => axios.post(`${API}/reviews`, payload);
export const fetchPublicReviews = (featured = false) =>
  axios.get(`${API}/reviews/public`, { params: featured ? { featured: true } : {} });
export const fetchPublicSettings = () => axios.get(`${API}/settings/public`);

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("r3-admin-token") || ""}` },
});
export const adminLogin = (email: string, password: string, rememberMe = false) =>
  axios.post(`${API}/admin/login`, { email, password, remember_me: rememberMe });
export const adminListUsers = () => axios.get(`${API}/admin/users`, authHeaders());
export const adminCreateUser = (payload: unknown) =>
  axios.post(`${API}/admin/users`, payload, authHeaders());
export const adminDeleteUser = (id: string) =>
  axios.delete(`${API}/admin/users/${id}`, authHeaders());
export const adminChangePassword = (payload: unknown) =>
  axios.post(`${API}/admin/change-password`, payload, authHeaders());
export const adminForgotPassword = (email: string) =>
  axios.post(`${API}/admin/forgot-password`, { email });
export const adminResetPassword = (payload: unknown) =>
  axios.post(`${API}/admin/reset-password`, payload);
export const adminStats = () => axios.get(`${API}/admin/stats`, authHeaders());
export const adminFetchBids = (status: string) =>
  axios.get(`${API}/admin/bids`, { params: { status }, ...authHeaders() });
export const adminPatchBid = (id: string, payload: unknown) =>
  axios.patch(`${API}/admin/bids/${id}`, payload, authHeaders());
export const adminFetchProjects = () => axios.get(`${API}/admin/projects`, authHeaders());
export const adminCreateProject = (fd: FormData) =>
  axios.post(`${API}/admin/projects`, fd, {
    headers: { Authorization: `Bearer ${localStorage.getItem("r3-admin-token") || ""}` },
  });
export const adminPatchProject = (id: string, payload: unknown) =>
  axios.patch(`${API}/admin/projects/${id}`, payload, authHeaders());
export const adminDeleteProject = (id: string) =>
  axios.delete(`${API}/admin/projects/${id}`, authHeaders());
export const fetchPublicProjects = () => axios.get(`${API}/projects/public`);
export const fetchPublicCompanies = () => axios.get(`${API}/companies/public`);
export const adminFetchCompanies = () => axios.get(`${API}/admin/companies`, authHeaders());
export const adminCreateCompany = (fd: FormData) =>
  axios.post(`${API}/admin/companies`, fd, {
    headers: { Authorization: `Bearer ${localStorage.getItem("r3-admin-token") || ""}` },
  });
export const adminPatchCompany = (id: string, payload: unknown) =>
  axios.patch(`${API}/admin/companies/${id}`, payload, authHeaders());
export const adminDeleteCompany = (id: string) =>
  axios.delete(`${API}/admin/companies/${id}`, authHeaders());
export const adminPlanUrl = (path: string) => `${API}/admin/files/${path}`;
export const adminFetchReviews = (status: string) =>
  axios.get(`${API}/admin/reviews`, { params: { status }, ...authHeaders() });
export const adminPatchReview = (id: string, payload: unknown) =>
  axios.patch(`${API}/admin/reviews/${id}`, payload, authHeaders());
export const adminGetSettings = () => axios.get(`${API}/admin/settings`, authHeaders());
export const adminPutSettings = (payload: unknown) =>
  axios.put(`${API}/admin/settings`, payload, authHeaders());
